import React from "react";
import { decode } from "html-entities";
import { Link } from "react-router-dom";
import { getUploadsUrl } from "../../config";

export default function BlogGrid({ posts, showPlaceholder = false }) {
    // When posts is falsy and we're not explicitly loading, render nothing.
    if (!posts || !posts.length) {
        if (showPlaceholder) {
            // Render several skeleton cards matching the grid layout
            const placeholders = new Array(6).fill(0);
            return (
                <section className="container sec-blog-grid">
                    <div className="blog-grid">
                        {placeholders.map((_, idx) => (
                            <div className="post-card card skeleton" key={`ph-${idx}`}>
                                <div className="thumb">
                                    <div className="graphic graphic--fill">
                                        <span className="dots"></span>
                                        <div className="graphic-center">
                                            <span className="initials placeholder-box" />
                                        </div>
                                    </div>
                                </div>
                                <div className="body">
                                    <span className="kicker placeholder-line small" />
                                    <h3 className="placeholder-line title" />
                                    <p className="placeholder-line" />
                                    <span className="read placeholder-line tiny" />
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            );
        }
        return null;
    }

    return (
        <section className="container sec-blog-grid">
            <div className="blog-grid">
                {posts.map((p) => (
                    <Link to={`/blog/${p.slug}`} className="post-card card" key={p.id}>
                        <div className="thumb">
                            <div className="graphic graphic--fill">
                                <span className="dots"></span>
                                <div className="graphic-center">
                                        {p.feature_image_url ? (
                                        <img loading="lazy" src={getUploadsUrl('posts', p.feature_image_url)} alt={p.feature_image_name || p.title} />
                                    ) : (
                                        <span className="initials">{(p.title||'').split(' ').map(s=>s[0]).slice(0,2).join('').toUpperCase()}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="body">
                            {p.category_name && p.category_name.toLowerCase() !== "uncategorized" && (
                                <span className="kicker">{decode(p.category_name)}</span>
                            )}
                            <h3>{decode(p.title)}</h3>
                            <p>{decode(p.short_description)}</p>
                            <span className="read">{p.read_time || ''}</span>
                        </div>
                    </Link>
                ))}
            </div>
        </section>
    );
}
